import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", {
  class: "fl fw600",
  style: {"width":"150px","margin-left":"5%"}
}, "招待する", -1)
const _hoisted_3 = {
  key: 0,
  class: "fl"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "fl mt15"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  id: "editor",
  class: "emailsContent",
  contenteditable: "true",
  placeholder: "メールアドレスを1行ごとに入力"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "fl",
  style: {"margin-left":"30px","margin-top":"-5px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs9" }, "役割", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 3,
  class: "fl ml30"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs9" }, "自動で作成する調整ページを選択", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  class: "",
  style: {"height":"100px"}
}
const _hoisted_15 = {
  class: "fl skyblue fs20 ml10",
  style: {"width":"24px"}
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt5 mr10" }, "通常の1on1の調整ページ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = {
  class: "fl skyblue fs20 ml10",
  style: {"width":"24px"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt5 mr10" }, "1on1の提案受け調整ページ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = {
  class: "fl skyblue fs20 ml10",
  style: {"width":"24px"}
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt5 mr10" }, "複数人の投票用ページ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = { class: "fl" }
const _hoisted_31 = {
  key: 1,
  class: "w100"
}
const _hoisted_32 = { class: "ml40 pad40 rad20 mt40" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "fs14" }, [
  /*#__PURE__*/_createTextVNode(" クライアントユーザーグループのメンバーを招待します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("招待することで、管理画面で日程の確定状況を確認することができるようになります。 ")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, "招待する企業名と担当者名を入力してください。", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, "ユーザー情報", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.type == `my_ug`)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          id: "form",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
        }, [
          (_ctx.emailDisplayType == `solo`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_MdTextfieldTag, {
                  name: "メールアドレス",
                  style: {"height":"56px","min-width":"280px"},
                  class: "fl fs14",
                  value: _ctx.invitedUserEmail,
                  onInputValue: _ctx.inputEmail,
                  onBlur: _ctx.checkEmailField,
                  errMessage: _ctx.failedMail ? `不正なメールアドレスです` : null,
                  required: ""
                }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"]),
                _hoisted_4,
                _createElementVNode("div", {
                  class: "fl pointer fs11 skyblue",
                  style: {"margin-top":"-5px"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.registMulti && _ctx.registMulti(...args)))
                }, "複数まとめて招待")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
          (_ctx.showContent())
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_SelectTag, {
                  name: "meeting_time",
                  id: "select_meeting_time",
                  class: "fl fs14 roundForm",
                  style: {"min-width":"130px","height":"50px"},
                  options: _ctx.SelectUtil.selectUserGroupRoles,
                  defaultOption: _ctx.getDefaultOption,
                  onSelectValue: _ctx.selectRoleNewMember
                }, null, 8, ["options", "defaultOption", "onSelectValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showContent())
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", {
                      class: _normalizeClass(`pointer borderGrey ${_ctx.selectCreateRoomTypes.includes(`simple`) ? `lskyblueBg` : ``}`),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickCreateRoomCell(`simple`)))
                    }, [
                      _createElementVNode("p", _hoisted_15, [
                        (_ctx.selectCreateRoomTypes.includes(`simple`))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "✔"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, " "))
                      ]),
                      _hoisted_18,
                      _hoisted_19
                    ], 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(`pointer borderGrey ${_ctx.selectCreateRoomTypes.includes(`simple_suggest`) ? `lskyblueBg` : ``}`),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickCreateRoomCell(`simple_suggest`)))
                    }, [
                      _createElementVNode("p", _hoisted_20, [
                        (_ctx.selectCreateRoomTypes.includes(`simple_suggest`))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "✔"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_22, " "))
                      ]),
                      _hoisted_23,
                      _hoisted_24
                    ], 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(`pointer borderGrey ${_ctx.selectCreateRoomTypes.includes(`voting`) ? `lskyblueBg` : ``}`),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickCreateRoomCell(`voting`)))
                    }, [
                      _createElementVNode("p", _hoisted_25, [
                        (_ctx.selectCreateRoomTypes.includes(`voting`))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "✔"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_27, " "))
                      ]),
                      _hoisted_28,
                      _hoisted_29
                    ], 2)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              type: "submit",
              class: "pointer centered circle_button skyblueBg fs16 rad8",
              style: {"width":"180px","height":"50px","padding":"14px 8px","margin-left":"20px","margin-top":"15px"},
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendInviteMail && _ctx.sendInviteMail(...args)))
            }, " 招待メールを送信 ")
          ])
        ], 32))
      : (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("div", null, [
              _hoisted_34,
              _createVNode(_component_MdTextfieldTag, {
                name: "企業名（様不要）",
                style: {"height":"56px","min-width":"280px","width":"280px"},
                class: "fl fs14",
                value: _ctx.newClientInfo.company_name,
                onInputValue: _ctx.inputClientCompanyName
              }, null, 8, ["value", "onInputValue"]),
              _hoisted_35
            ]),
            _createElementVNode("div", null, [
              _hoisted_36,
              _createVNode(_component_MdTextfieldTag, {
                name: "担当者名（様不要）",
                style: {"height":"56px","min-width":"280px","width":"280px"},
                class: "fl fs14 mr10",
                value: _ctx.newClientInfo.name,
                onInputValue: _ctx.inputClientName
              }, null, 8, ["value", "onInputValue"]),
              _createVNode(_component_MdTextfieldTag, {
                name: "メールアドレス",
                style: {"height":"56px","min-width":"280px","width":"280px"},
                class: "fl fs14 mr10",
                value: _ctx.newClientInfo.email,
                onInputValue: _ctx.inputClientEmail,
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkEmailField(_ctx.newClientInfo.email))),
                errMessage: _ctx.failedMail ? `不正なメールアドレスです` : null
              }, null, 8, ["value", "onInputValue", "errMessage"]),
              _createElementVNode("button", {
                type: "submit",
                class: "fl pointer centered circle_button fs14 rad8 noborder skyblueBg mt10",
                style: {"height":"50px"},
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.inviteNewClient && _ctx.inviteNewClient(...args)))
              }, " 招待 "),
              _hoisted_37
            ]),
            _hoisted_38
          ])
        ])),
    _hoisted_39
  ]))
}